module.exports = __webpack_public_path__ + "img/9b44746.svg";